import "../../common/ModalWindow.css";
import ModalWindow from "../../common/ModalWindow";
import BasicTextInput from "../../common/TextInput";
import {BasicButton} from "../../common/Button";
import {useContext, useRef, useState} from "react";
import {UserActions, UserDispatchContext} from "../../contexts/UserContext";
import SpinLoadingIndicator from "../../common/SpinLoadingIndicator";
import {backend, BackendResult} from "../../model/Backend";
import ErrorMessage from "../../common/ErrorMessage";

export default function RegisterModal({onClose}) {
    const [errorData, setErrorData] = useState(null);
    const [registering, setRegistering] = useState(false);
    const userDispatch = useContext(UserDispatchContext);

    const userEmail = useRef(null);
    const userPassword = useRef(null);
    const userPasswordRepeat = useRef(null);

    async function onSubmit(submitEvent) {
        submitEvent.preventDefault();
        if (registering)
            return; // this probably shouldn't happen
        if (userPassword.current.value !== userPasswordRepeat.current.value) {
            setErrorData(BackendResult.FromError("Passwords don't match."));
            return;
        }
        const registerData = {
            email: userEmail.current.value,
            password: userPassword.current.value,
        };

        setErrorData(null);
        setRegistering(true);
        const result = await backend.register(registerData);
        setRegistering(false);

        if (!result.isSuccess()) {
            setErrorData(result);
        } else {
            setErrorData(null);
            userDispatch({
                type: UserActions.Login, user: result.data
            });
            onClose();
        }
    }

    return (
        <ModalWindow handleClose={onClose}>
            <h1 className="text-4xl">Register</h1>

            <form onSubmit={onSubmit}>
                <div className="mb-5"></div>
                <BasicTextInput ref={userEmail} type="email" name="email" required={true} label="Email"
                                autoComplete="username"/>
                <div className="mb-4"></div>
                <BasicTextInput ref={userPassword} type="password" name="password" required={true} label="Password"
                                autoComplete="new-password"/>
                <div className="mb-4"></div>
                <BasicTextInput ref={userPasswordRepeat} type="password" name="password_repeat" required={true}
                                label="Confirm Password" autoComplete="new-password"/>
                <div className="mb-5"></div>
                <ErrorMessage data={errorData}/>
                <BasicButton type="submit" disabled={registering}>
                    {!registering ? "Register" : <SpinLoadingIndicator/>}
                </BasicButton>
            </form>
        </ModalWindow>
    )
}
